import React from "react";
import { Link } from "react-router-dom";
import { NAV_LINKS } from "./Header";

export default function Footer() {
  return (
    <footer className="sle-footer" data-testid="site-footer">
      <div className="footer-brand">
        <span className="s-shillong">Shillong</span>{" "}
        <span className="s-lucky">Lucky</span>{" "}
        <span className="s-ending">Ending</span>
      </div>
      <div className="footer-links">
        {NAV_LINKS.map((l) => (
          <Link key={l.path} to={l.path} data-testid={`footer-${l.path.replace(/\//g, "") || "home"}`}>
            {l.label}
          </Link>
        ))}
      </div>
      <div className="footer-note">
        For entertainment &amp; informational purposes only. Strictly for users 18 years or older. Please play
        responsibly.
      </div>
      <div className="footer-copy">© {new Date().getFullYear()} Shillong Lucky Ending. All rights reserved.</div>
    </footer>
  );
}
